import React from 'react'
import { useSelector } from 'react-redux'
function HeaderTitle() {
    const user = useSelector((state) => state.login.user)
    console.log(user)
  return (
    <h2 className='d-flex align-items-center mb-4'><span className="text-black fw-bold  ">Welcome Admin {user.firstName}!</span> <span className='useremail'>{'<'+user.email+'>'}</span></h2>
  )
}

export default HeaderTitle